<template>
    <div>
        <Head title="Contact" />
        <section class="relative z-10 overflow-hidden bg-primary pt-[120px] pb-[50px] md:pt-[130px] lg:pt-[160px]">
            <div class="container">
                <div class="-mx-4 flex flex-wrap items-center">
                    <div class="w-full px-4">
                        <div class="text-center text-white">
                            <h1 class="text-4xl font-semibold ">{{ user.first_name }} {{ user.last_name }}</h1>
                            <div class="user___details pt-8 flex justify-center text-center" v-html="user.details" />
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->
            <div>
                <span class="absolute top-0 left-0 z-[-1]">
                    <img src="/landing/images/header/shape-1.svg" alt="" />
                </span>
                <span class="absolute top-0 right-0 z-[-1]">
                    <img src="/landing/images/header/shape-2.svg" alt="" />
                </span>
            </div>
        </section><!--end section-->
        <section class="relative md:py-3 mb-20">
            <div class="container pb-5">
                <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px] event___types">
                    <div v-for="event_type in event_types" :key="event_type.id" class="et__ p-6 transition duration-500 mt-6 shadow shadow-gray-100 dark:shadow-gray-800 cursor-pointer" @click="goToEventType(event_type.link)">
                        <div class="flex">
                            <div class="flex w-6 h-6 event__color rounded-full " :style="{'background-color': event_type.color}"></div>
                            <div class="flex title h5 text-lg font-bold pl-3">{{ event_type.name }}</div>
                        </div>

                        <div class="e__time pt-3 flex items-center justify-start gap-2">
                            <icon name="clock" class="w-4 h-4" />
                            <div class="__time">{{ event_type.duration.replace('_',' ') }}</div>
                        </div>

                        <div class="content mt-3">
                            <p class=" mt-2">{{ event_type.details.length < 61 ? strippedContent(event_type.details) : strippedContent(event_type.details).substring(0, 61) + "..." }}</p>
                        </div>
                        <div class="flex pt-5 justify-between items-center">
                            <div class="bar_highlight h-8 flex items-center justify-start"><icon name="bar-highlight" class="h-1" /></div>
                            <div class="arrow flex items-center justify-start h-8">Read More <icon name="cheveron-right" class="w-5 h-5" /> </div>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->
        </section>
        <!-- End Section-->

    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import { Head } from '@inertiajs/inertia-vue3'
import sanitizeHtml from "sanitize-html";
export default {
    layout: Layout,
    components: {
        Icon,
        Head,
    },
    props: {
        user: Object,
        event_types: Object,
    },
    data() {
        return {
            page: null
        }
    },
    methods:{
        sanitizeHtml : sanitizeHtml,
        strippedContent(html) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        goToEventType(link){
            window.location.href = this.route('event_type.schedule', {username: this.user.username, event_type: link})
        },
    },
    created() {
        console.log(this.event_types)
    }
}
</script>
